// src/parts/AboutUsPage.jsx
import React from "react";
import Team from "./team"; // Assuming Team component is still used
import 'aos/dist/aos.css'; // AOS is used in Mission/Vision sections
import { motion } from "framer-motion"; // Framer Motion is used in Vision section

export default function AboutUsPage() {
  return (
    <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-extrabold text-center text-gray-900 mb-12">About Us</h1>

        {/* About Us Content (from original AboutUs.jsx, which renders Team) */}
        <section className="mb-16">
          <Team />
        </section>

        {/* Mission Content */}
        <section className="container mx-auto py-16 px-4">
          <div className="flex flex-col lg:flex-row lg:space-x-8">
            <div
              data-aos="fade-in"
              className="flex flex-col items-center p-8 justify-center border border-gray-200 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 w-full">
              <h2 className="flex justify-center text-bg text-3xl font-bold mb-14">
                Our Mission
              </h2>
              <p className="sm:px-2 lg:px-20 md:px-20 text-gray-700 text-center">
                To deliver exceptional culinary experiences both in our restaurant
                and through our tailored catering services. <br /><br /> We are dedicated
                to providing high-quality, freshly prepared dishes that exceed our
                clients’ expectations, whether for intimate gatherings or large
                events. <br /><br /> Our mission is to bring people together through food,
                offering personalized service and attention to detail that ensures
                every event is a memorable success.
              </p>
            </div>
          </div>
        </section>

        {/* Vision Content */}
        <section className="container mx-auto py-16 px-4">
          <div className="flex flex-col lg:flex-row lg:space-x-8">
            <motion.div
              data-aos="fade-right"
              className="flex flex-col items-center p-8 justify-center border border-gray-200 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 w-full"
              whileHover={{ scale: 1.05 }}
            >
              <h2 className="text-center text-bg text-4xl font-bold mb-12">
                Our <span className="text-hovered">Vision</span>
              </h2>
              <p className="mb-6 sm:px-2 lg:px-20 md:px-20 text-gray-700 text-center">
                To be the premier choice for catering services, renowned for our
                exceptional culinary creations, impeccable service, and unwavering
                commitment to customer satisfaction while maintaining our core
                values of honesty and excellence.
              </p>
            </motion.div>
          </div>
        </section>

      </div>
    </div>
  );
}
